import { StatusBadge } from "@/components/StatusBadge";

/** Funil comercial — visível apenas para administradores. Clicar filtra a lista. */
export const StatusFunnel = ({ counts = [], activeStatus = "", onSelect }) => {
  if (!counts.length) return null;
  return (
    <div data-testid="status-funnel" className="flex flex-wrap gap-2">
      {counts.map((c) => (
        <button key={c.slug} data-testid={`funnel-${c.slug}`}
                onClick={() => onSelect(activeStatus === c.slug ? "" : c.slug)}
                className={`flex items-center gap-2 rounded-md border px-3 py-2 transition-colors ${
                  activeStatus === c.slug
                    ? "border-[#2563EB] bg-[#132038]"
                    : "border-[#22252F] bg-[#12141A] hover:border-[#2563EB]/50"}`}>
          <StatusBadge slug={c.slug} label={c.label} />
          <span className="font-mono text-sm text-white">{c.count}</span>
        </button>
      ))}
    </div>
  );
};
